// extracted by mini-css-extract-plugin
module.exports = {"main":"sticky_main__3_8_z","mainsmall":"sticky_mainsmall__1sPiX","agenda":"sticky_agenda__B8oUp","menu":"sticky_menu__ESFpo"};